// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".operate-div[data-v-08cc0692]{display:flex;align-items:center;justify-content:center}.info-box ul[data-v-08cc0692]{text-align:left;list-style:none;color:#fff}.info-box ul li[data-v-08cc0692]{margin:10px 5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
